import { fr } from "./fr";
import { en } from "./en";
import { es } from "./es";

export const CONTENT = { fr, en, es };

export const LANGS = [
  { code: "fr", flag: "🇫🇷", label: "FR" },
  { code: "en", flag: "🇬🇧", label: "EN" },
  { code: "es", flag: "🇪🇸", label: "ES" },
];

export const getContent = (lang) => CONTENT[lang] || CONTENT.fr;
